export enum ProductType {
    DNATest = "DNA Test",
    Consultancy = "Consulto Medico",
    DNATestAndSub = "DNA Test + Subscription",
}